import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from 'vue-cookies';
import axios from 'axios';
import yaml from 'js-yaml';
import { Message } from 'element-ui';

Vue.config.productionTip = false
Vue.use(ElementUI, {size:'small'});
Vue.use(VueCookies);

// 设置axios为Vue的http模块
Vue.prototype.$http = axios;

// 添加axios响应拦截器，处理401未授权错误
let isRedirecting = false; // 防止重复跳转

axios.interceptors.response.use(
  response => {
    // 如果响应正常，直接返回
    return response;
  },
  error => {
    // 处理错误响应
    if (error.response) {
      // 检查是否是401未授权错误
      if (error.response.status === 401 && !isRedirecting) {
        // 获取请求的URL
        const requestUrl = error.config.url || '';
        
        // 排除登录和注册接口，这些接口的401是正常的业务错误（用户名密码错误等）
        const isAuthEndpoint = requestUrl.includes('/api/user/login') || 
                               requestUrl.includes('/api/user/register');
        
        // 只对非登录注册接口的401错误进行自动退出处理
        if (!isAuthEndpoint) {
          isRedirecting = true;
          
          // 清除token和相关信息
          document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
          document.cookie = 'satoken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
          sessionStorage.removeItem('userInfo');
          
          // 显示提示消息
          Message({
            message: '登录已过期，请重新登录',
            type: 'warning',
            duration: 3000
          });
          
          // 跳转到登录页
          setTimeout(() => {
            isRedirecting = false;
            router.push('/').catch(err => {
              // 忽略导航到相同路由的错误
              if (err.name !== 'NavigationDuplicated') {
                console.error('导航错误:', err);
              }
            });
          }, 500);
        }
      }
    }
    // 继续抛出错误，让业务代码可以继续处理
    return Promise.reject(error);
  }
);

// 添加配置加载函数
Vue.prototype.$loadConfig = async function() {
  try {
    const response = await axios.get('/group_tags_zh_CN.yaml');
    const config = yaml.load(response.data);

    // 提取所有的tags
    const configTags = {};
    config.forEach(item => {
      item.groups.forEach(group => {
        if (group.tags) {
          Object.assign(configTags, group.tags);
        }
      });
    });

    return { config, configTags };
  } catch (error) {
    console.error('Error loading YAML file:', error);
    return { config: null, configTags: null };
  }
}

// 创建Vue实例并挂载
new Vue({
  router,
  render: h => h(App),
  created() {
    // 在Vue实例创建时加载配置
    this.$loadConfig().then(({ config, configTags }) => {
      Vue.prototype.$config = config;
      Vue.prototype.$configTags = configTags;
    });
  }
}).$mount('#app')




// import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// import VueCookies from 'vue-cookies';
// import VueLazyload from 'vue-lazyload'
// import axios from 'axios';
//
// Vue.config.productionTip = false
// Vue.use(ElementUI, { size: 'small' });
// Vue.use(VueCookies);
// Vue.use(VueLazyload);
//
// // 设置axios为Vue的http模块
// Vue.prototype.$http = axios;
//
// // 添加一个响应拦截器
// axios.interceptors.response.use(response => {
//   // 如果响应是正常的，则直接返回response
//   return response;
// }, error => {
//   // 如果响应是错误的，检查状态码
//   if (error.response && (error.response.status === 502 || error.response.status === 503 || error.response.status === 504)) {
//     // 如果是502、503或504错误，则跳转到维护页面
//     window.location.href = '/error/500.html';
//   }
//   // 如果是其他错误，返回错误信息
//   return Promise.reject(error);
// });
//
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')
